module.exports = __webpack_public_path__ + "static/media/color-black.5cf1d40c.svg";